var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4382 3.14969L12.9048 5.93635C13.1048 6.32427 13.6382 6.69635 14.0882 6.7676L16.7465 7.18719C18.4465 7.45635 18.8465 8.62802 17.6215 9.78385L15.5548 11.7472C15.2048 12.0797 15.0132 12.7209 15.1215 13.1801L15.7132 15.6105C16.1798 17.5343 15.1048 18.2784 13.3132 17.273L10.8215 15.8718C10.3715 15.6184 9.62984 15.6184 9.17151 15.8718L6.67984 17.273C4.89651 18.2784 3.81317 17.5264 4.27984 15.6105L4.87151 13.1801C4.97984 12.7209 4.78817 12.0797 4.43817 11.7472L2.37151 9.78385C1.15484 8.62802 1.54651 7.45635 3.24651 7.18719L5.90484 6.7676C6.34651 6.69635 6.87984 6.32427 7.07984 5.93635L8.54651 3.14969C9.34651 1.6376 10.6465 1.6376 11.4382 3.14969Z",
    stroke: "#C93030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.f177079c86b8abacb5d5b81fa3e716c4.svg";
export { ForwardRef as ReactComponent };